import GanttToolbarProps from './Toolbar'

let KendoGanttColumn = {
    name: 'kendo-gantt-toolbar-item',
    render () {
        return null
    },
    mixins: [GanttToolbarProps]
}

export default KendoGanttColumn


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGanttToolbar/index.js